import Block from './Block'
import gsap from 'gsap'

export default class LastPosts extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    this.bM()
    this.elems()
    this.addEvents()
  }

  bM() {
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
  }

  elems() {
    this.cards = [];
    this.$cards = this.el.querySelectorAll('.card-post')

    for (let i = 0; i < this.$cards.length; i++) {
      this.cards.push({
        el: this.$cards[i],
        img: this.$cards[i].querySelector('.card-post__image-inner')
      })
    }
  }

  addEvents() {
    for (let i = 0; i < this.cards.length; i++) {
      this.cards[i].img && this.cards[i].el.addEventListener('mouseenter', this.onMouseEnter)
      this.cards[i].img && this.cards[i].el.addEventListener('mouseleave', this.onMouseLeave)
    }
  }

  init() {
    this.bM()
    this.elems()
    this.addEvents()
  }

  destroy() {
    for (let i = 0; i < this.cards.length; i++) {
      this.cards[i].img && this.cards[i].el.removeEventListener('mouseenter', this.onMouseEnter)
      this.cards[i].img && this.cards[i].el.removeEventListener('mouseleave', this.onMouseLeave)
    }
  }

  onMouseEnter(e) {
    const index = this.cards.findIndex((x) => x.el === e.target)

    gsap.fromTo(this.cards[index].img, {
      y: 200,
      x: -30,
      rotate: 15,
      opacity: 0
    },
    {
      y: 0,
      x: 0,
      rotate: -5,
      opacity: 1,
      ease: 'power3.out',
      duration: 0.5
    })
  }

  onMouseLeave(e) {
    const index = this.cards.findIndex((x) => x.el === e.target)

    gsap.to(this.cards[index].img, {
      y: -200,
      x: -30,
      rotate: -20,
      opacity: 0,
      ease: 'power3.out',
      duration: 0.5
    })
  }
}
